export const LEFT_TOP = 0;
export const MIDDLE_TOP = 1;
export const RIGHT_TOP = 2;
export const LEFT_MIDDLE = 3;
export const MIDDLE_MIDDLE = 4;
export const RIGHT_MIDDLE = 5;
export const LEFT_BOTTOM = 6;
export const MIDDLE_BOTTOM = 7;
export const RIGHT_BOTTOM = 7;
